import React, { useEffect, useState } from "react";
import OddButton from "../OddButton/oddbutton";
import BetPlacing from "../BetPlacing/BetPlacing";
import SVG_BroadCastIcon from "../../assets/images/svgs/inplay-broadcast.svg?react";
import { headerType } from "../../helpers/InPlayPopular.helper";
import {
  getFormattedDate,
  getZonedTime,
  inplayTimer,
} from "../../helpers/date.helper";
import { useDispatch, useSelector } from "react-redux";
import {
  addfavoritesItem,
  clearfavoritesItem,
  addfavoritesItemPop,
  clearfavoritesItemPop,
  addFavoritesAll,
  clearFavoritesAll,
} from "../../store/favorites/favorites.slice";
import { useInView } from "react-intersection-observer";
import { setLoginNew } from "../../store/LoginNew/loginNew.slice";
import { setLoginNavigationData } from "../../store/loginNavigation/LoginNavigation.slice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  requestSportPageEvent,
  requestSportPageEventDetailed,
} from "../../store/sportPageEvent/sportPageEvent.thunks";
import { requestCompetition } from "../../store/competitions/competitions.thunks";
import {
  setHrEventId,
  setHrMarketId,
  setIsDetailedGroupName,
  setIsEventDetailed,
  setIsNavigationID,
  setIsNavigationName,
  setIsNavigationOpen,
} from "../../store/navigationHeaderMenu/navigationHeaderMenu.slice";
import { requestHomeAllCompetition } from "../../store/homeMarketEvents/homeMarketEvents.thunks";
import { TvSVG } from "../SvgImage/SvgImage";

const InPlayItem = ({
  type,
  itemData,
  timeSettings,
  displayedBack,
  setDisplayedBack,
  betPlacing,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [item, setItem] = useState(null);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [openPopUp, setOpenPopUp] = useState(false);

  const checkStateWidth = useSelector(
    (state) => state.elementsParams.clientWidth
  );
  const width = checkStateWidth ? checkStateWidth : window.innerWidth;
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const { ref: inplayItemRef, inView } = useInView({
    threshold: 0.2, // Trigger when 10% of the item is in view
  });

  useEffect(() => {
    setItem(itemData);
  }, [itemData]);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 1) {
      setDisplayedBack(true);
    }

    if (touchStart - touchEnd < -1) {
      setDisplayedBack(false);
    }

    setTouchEnd(0);
    setTouchStart(0);
  };

  const gotoEvent = () => {
    if (!auth) {
      dispatch(setLoginNew(true));
      dispatch(
        setLoginNavigationData(
          item.sport_id == "77777"
            ? { page: "casino_live", ids: [item.match_id] }
            : { page: "event-page", ids: [itemData.sport_id, item.match_id] }
        )
      );
    } else if (item.sport_id == "77777")
      navigate(`/casino_live/${item.match_id}`);
    else {
      dispatch(setIsDetailedGroupName(itemData?.series_name));
      dispatch(setIsEventDetailed(false));
      const data = {
        sport_id: itemData?.sport_id,
      };

      dispatch(requestHomeAllCompetition(data));

      if (itemData?.sport_id === "7" || itemData?.sport_id === "4339") {
        dispatch(setIsNavigationID(itemData?.sport_id));
        dispatch(
          setIsNavigationName(
            itemData?.sport_id === "7" ? "Horse Racing" : "Greyhound Racing"
          )
        );
        dispatch(setHrEventId(itemData.match_id));
        dispatch(setHrMarketId(itemData?.market_id));

        navigate(
          itemData?.sport_id === "7" ? "/horse-racing" : "/greyhound-racing"
        );
        return;
      }
      navigate(`/event-page/${itemData.sport_id}/${item.match_id}/${item?.match_name}`);

      if (width < 1024) {
        setOpenPopUp(true);
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setOpenPopUp(false);
    }, 600);
  }, [openPopUp]);

  const getOdds = () => {
    if (!item) return;

    let newOdds = {
      back: [
        {
          runner: {
            id: item?.runners[0]?.selectionId || null,
            name: item?.runners[0]?.selection_name || null,
            status: item?.runners[0]?.status || null,
          },
          price: item?.runners[0]?.ex?.availableToBack[0]?.price || null,
          size: item?.runners[0]?.ex?.availableToBack[0]?.size || null,
          line: item?.runners[0]?.ex?.availableToBack[0]?.line || null,
        },
        {
          runner: {
            id: item?.runners[1]?.selectionId || null,
            name: item?.runners[1]?.selection_name || null,
            status: item?.runners[1]?.status || null,
          },
          price: item?.runners[1]?.ex?.availableToBack[0]?.price || null,
          size: item?.runners[1]?.ex?.availableToBack[0]?.size || null,
          line: item?.runners[1]?.ex?.availableToBack[0]?.line || null,
        },
        {
          runner: {
            id: item?.runners[2]?.selectionId || null,
            name: item?.runners[2]?.selection_name || null,
            status: item?.runners[2]?.status || null,
          },
          price: item?.runners[2]?.ex?.availableToBack[0]?.price || null,
          size: item?.runners[2]?.ex?.availableToBack[0]?.size || null,
          line: item?.runners[2]?.ex?.availableToBack[0]?.line || null,
        },
      ],
      lay: [
        {
          runner: {
            id: item?.runners[0]?.selectionId || null,
            name: item?.runners[0]?.selection_name || null,
            status: item?.runners[0]?.status || null,
          },
          price: item?.runners[0]?.ex?.availableToLay[0]?.price || null,
          size: item?.runners[0]?.ex?.availableToLay[0]?.size || null,
          line: item?.runners[0]?.ex?.availableToLay[0]?.line || null,
        },
        {
          runner: {
            id: item?.runners[1]?.selectionId || null,
            name: item?.runners[1]?.selection_name || null,
            status: item?.runners[1]?.status || null,
          },
          price: item?.runners[1]?.ex?.availableToLay[0]?.price || null,
          size: item?.runners[1]?.ex?.availableToLay[0]?.size || null,
          line: item?.runners[1]?.ex?.availableToLay[0]?.line || null,
        },
        {
          runner: {
            id: item?.runners[2]?.selectionId || null,
            name: item?.runners[2]?.selection_name || null,
            status: item?.runners[2]?.status || null,
          },
          price: item?.runners[2]?.ex?.availableToLay[0]?.price || null,
          size: item?.runners[2]?.ex?.availableToLay[0]?.size || null,
          line: item?.runners[2]?.ex?.availableToLay[0]?.line || null,
        },
      ],
    };

    const status = item?.status;
    const odds = newOdds;
    const back = odds?.back;
    const lay = odds?.lay;

    if (status && status?.toUpperCase() !== "OPEN") {
      return (
        <span className=" col-span-6 h-12 lg:col-span-7 w-full overflow-auto border-t border-borderColorOfMarket border-b">
          <span className="w-full flex items-center  justify-center h-full">
            <span className="text-xs text-center w-full h-full flex items-center bg-bg_SuspendedBgColor text-text_SuspendedFontColor font-bold justify-center rounded-sm">
              {status.toUpperCase()}
            </span>
          </span>
        </span>
      );
    }

    return width < 640 ? (
      <>
        <span className=" col-span-6 h-12 lg:col-span-7 w-full overflow-auto border-t border-borderColorOfMarket ">
          <div
            className="w-full overflow-x-auto flex h-full sm:px-[2px]"
            id="hideScrollBar"
          >
            <span className="grid grid-cols-12 grid-flow-col overflow-auto h-full min-w-[100%]">
              <span className="col-span-4">
                <OddButton
                  market={item}
                  isBack={true}
                  oddData={back && back[0]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </span>
              <span className="col-span-4">
                <OddButton
                  market={item}
                  isBack={true}
                  oddData={back && back[2]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </span>

              <span className="col-span-4">
                <OddButton
                  market={item}
                  isBack={true}
                  oddData={back && back[1]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </span>
            </span>

            <span className="grid grid-cols-12 grid-flow-col overflow-auto h-full min-w-[100%]">
              <span className="col-span-4">
                <OddButton
                  market={item}
                  isBack={false}
                  oddData={lay && lay[0]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </span>
              <span className="col-span-4">
                <OddButton
                  market={item}
                  isBack={false}
                  oddData={lay && lay[2]}
                  centered
                  isInactive={
                    type == "popular" || !status?.toUpperCase() !== "OPEN"
                  }
                />
              </span>
              <span className="col-span-4">
                <OddButton
                  market={item}
                  isBack={false}
                  oddData={lay && lay[1]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </span>
            </span>
          </div>
        </span>
      </>
    ) : (
      <>
        <span className=" col-span-6 h-12 lg:col-span-7 w-full overflow-auto border-t border-borderColorOfMarket ">
          <div className="w-full grid grid-cols-12 grid-flow-col overflow-auto h-full">
            <div className="col-span-4 grid grid-cols-2 h-full">
              <div className="w-full h-full">
                <OddButton
                  market={item}
                  isBack={true}
                  oddData={back && back[0]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </div>
              <div className="w-full h-full">
                <OddButton
                  market={item}
                  isBack={false}
                  oddData={lay && lay[0]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </div>
            </div>

            <div className="col-span-4 grid grid-cols-2 h-full">
              <div className="w-full h-full">
                <OddButton
                  market={item}
                  isBack={true}
                  oddData={back && back[2]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </div>
              <div className="w-full h-full">
                <OddButton
                  market={item}
                  isBack={false}
                  oddData={lay && lay[2]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </div>
            </div>

            <div className="col-span-4 grid grid-cols-2 h-full">
              <div className="w-full h-full">
                <OddButton
                  market={item}
                  isBack={true}
                  oddData={back && back[1]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </div>
              <div className="w-full h-full">
                <OddButton
                  market={item}
                  isBack={false}
                  oddData={lay && lay[1]}
                  centered
                  isInactive={
                    type == "popular" || status?.toUpperCase() !== "OPEN"
                  }
                />
              </div>
            </div>
          </div>
        </span>
      </>
    );
  };

  const getName = () => {
    if (!item) return;

    const players = item.runners || item?.marketBook?.runners;
    if (!players) {
      return (
        <div
          className="inplay-item__players"
          onClick={() => {
            gotoEvent();
          }}
        ></div>
      );
    }

    return (
      <>
        <span
          id="inPlayTeamName"
          className=" text-selection-none flex items-center justify-start col-span-5 px-1 relative border-l border-r border-borderColorOfMarket active:scale-[94%] transition-all ease-in-out duration-100"
          onClick={gotoEvent}
        >
          <span className="flex flex-col items-center justify-start w-[87%] cursor-pointer ">
            <>
              {item?.actualEventTypeId == "b9" ? (
                <span className=" text-selection-none w-full flex items-center justify-start">
                  <span className=" w-[5px] h-[5px] p-[1px] mr-[2px]"></span>
                  <span className=" text-[11px] font-bold text-text_Ternary  truncate sm:text-xs md:text-sm">
                    Ball By Ball
                  </span>
                </span>
              ) : item?.runners?.length > 3 ? (
                <span className=" text-selection-none w-full flex items-center justify-start">
                  <span className=" w-[5px] h-[5px] p-[1px] mr-[2px]"></span>
                  <span className=" text-[11px] font-bold text-text_Ternary  truncate sm:text-xs md:text-sm">
                    {item?.match_name}
                  </span>
                </span>
              ) : (
                (item?.runners).map((innerItem, index) => {
                  if (index >= 2) return;

                  return (
                    <span
                      className=" text-selection-none w-full flex items-center justify-start"
                      key={`${innerItem?.selectionId}_${index}`}
                    >
                      <span className=" w-[5px] h-[5px] p-[1px] mr-[2px]"></span>
                      <span className=" text-[11px] font-bold text-text_Ternary  truncate sm:text-xs md:text-sm">
                        {innerItem?.selection_name
                          ? innerItem?.selection_name
                          : item?.runners[index]?.selection_name}
                      </span>
                    </span>
                  );
                })
              )}
            </>
          </span>

          {item?.has_tv_url && (
            <span className="cursor-pointer absolute top-0.5 right-0.5">
              {/* <SVG_BroadCastIcon /> */}
              <TvSVG />
            </span>
          )}
        </span>
      </>
    );
  };

  const getScore = () => {
    // return getPopularScore();

    switch (type) {
      case headerType["INPLAY"]: {
        return getInplayScore();
      }

      case headerType["POPULAR"]: {
        return getPopularScore();
      }

      default:
        return;
    }
  };

  const getPopularScore = () => {
    if (!item) return;

    // const openDate = item.event && item.event.openDate
    const openDate = item?.match_date;
    if (!openDate) {
      return getNoScore();
    }

    const formattedOpenDate = getFormattedDate(
      openDate,
      timeSettings.timeZoneName
    );

    const targetDate = inplayTimer(
      getZonedTime(timeSettings?.timeZoneName, openDate)
    );

    // if()

    return (
      <span
        id="inPlayTime"
        className="flex  items-center justify-center flex-col col-span-2 pl-[1px] pr-[1px] active:scale-[94%] transition-all ease-in-out duration-100"
      >
        <span
          className={`text-[8px] xs:text-[9px] md:text-[10px] font-semibold  w-full text-center ${
            type == "inplay"
              ? "text-text_InPlayEventsScoreAndTime"
              : "text-text_UpcomingEvents"
          }`}
        >
          {targetDate}
        </span>
        {/* <span
          className={` ${
            type == "inplay"
              ? "text-text_InPlayEventsScoreAndTime"
              : "text-text_UpcomingEvents"
          } text-[6px] xs:text-[8px] md:text-[10px] font-semibold  w-full text-center uppercase`}
        >
          {formattedOpenDate?.time}
        </span> */}
      </span>
    );
  };

  const getNoScore = () => {
    const openDate = item?.match_date;
    if (item?.marketType == "virtual") {
      return (
        <span
          id="inPlayTime"
          className=" flex  items-center justify-center flex-col col-span-2 pl-[1px] pr-[1px] active:scale-[94%] transition-all ease-in-out duration-100"
        >
          <span
            className={` ${
              type == "inplay"
                ? "text-text_InPlayEventsScoreAndTime"
                : "text-text_UpcomingEvents"
            } text-[6px] xs:text-[8px] md:text-[10px] font-semibold  w-full text-center`}
          >
            NEW
          </span>
        </span>
      );
    }

    const formattedOpenDate = getFormattedDate(
      openDate,
      timeSettings.timeZoneName
    );

    const targetDate = inplayTimer(
      getZonedTime(timeSettings?.timeZoneName, openDate)
    );

    return (
      <span
        id="inPlayTime"
        className="flex  items-center justify-center flex-col col-span-2 pl-[1px] pr-[1px] active:scale-[94%] transition-all ease-in-out duration-100"
      >
        <span
          className={`text-[8px] xs:text-[9px] md:text-[10px] font-semibold  w-full text-center ${
            type == "inplay"
              ? "text-text_InPlayEventsScoreAndTime"
              : "text-text_UpcomingEvents"
          }`}
        >
          {targetDate}
        </span>
        {/* <span
          className={` ${
            type == "inplay"
              ? "text-text_InPlayEventsScoreAndTime"
              : "text-text_UpcomingEvents"
          } text-[6px] xs:text-[8px] md:text-[10px] font-semibold  w-full text-center uppercase`}
        >
          {formattedOpenDate?.time}
        </span> */}
      </span>
    );
  };

  const getInplayScore = () => {
    if (!item) return;

    const scores = item.scores;
    if (!scores) {
      return getNoScore();
    }

    switch (Number(item.sport_id)) {
      case 1: {
        // const penalty = scores.penalty;
        // TODO refactor
        const fulTime = Math.ceil(scores.time / 60000);
        const time = fulTime / 90 > 1 ? 90 : fulTime;
        const extraTime = fulTime % 90;

        const team1Score = scores.players[0].score;
        const team2Score = scores.players[1].score;

        return (
          <div className="score-content football">
            <span className="score-content__football-time">
              {time === 45 ? "HT" : `${time}’`}
            </span>
            {fulTime >= 90 && (
              <span className="score-content__football-time">
                + {extraTime}’
              </span>
            )}
            <span className="score-content__football-score-group">
              <span>{team1Score}</span>
              <span>{team2Score}</span>
            </span>
          </div>
        );
      }

      case 2: {
        const team1Won = scores.players[0].setsWon;
        const team2Won = scores.players[1].setsWon;
        const team1Score = scores.players[0].currentScore;
        const team2Score = scores.players[1].currentScore;
        return (
          <div className="score-content football">
            <span className="score-content__football-score-group won">
              <span>{team1Won}</span>
              <span>{team2Won}</span>
            </span>
            <span className="score-content__football-score-group">
              <span>{team1Score}</span>
              <span>{team2Score}</span>
            </span>
          </div>
        );
      }

      case 4: {
        const overs = scores.overs;
        const target = scores.target;
        const wickets = scores.wickets;
        const score = scores.score;
        const currentInning = scores.currentInning;

        return (
          <div className="score-content cricket">
            <span>{overs} Ov</span>
            {currentInning === 2 && <span>Tgt {target}</span>}
            <span>
              {score}/{wickets}
            </span>
          </div>
        );
      }

      case 77777: {
        return;
      }

      case 1444001: {
        return;
      }

      default:
        return;
    }
  };

  const renderBetPlacing = () => {
    const status = item?.status;
    const marketId =
      item && item?.market_id ? item?.market_id : item?.marketBook?.marketId;

    if (
      betPlacing.market &&
      betPlacing.market === marketId &&
      status &&
      !status.localeCompare("OPEN") &&
      width < 1024
    ) {
      return (
        <span className=" col-span-12 h-max w-full">
          <BetPlacing onClose={() => {}} />
        </span>
      );
    }
    return null;
  };

  const items = useSelector((state) => state.inplayPopular);
  const favoritesState = useSelector((state) => state.favorites);
  // const sportData = useSelector((state) => state.sportEvent.sportData)
  // console.log('sportData', sportData)

  localStorage.setItem("favorites", JSON.stringify(favoritesState));
  // const storagedFavorites = JSON.parse(localStorage.getItem('favorites'))

  const isFavorite = () => {
    if (
      favoritesState?.favoritesAll?.length > 0 &&
      item &&
      favoritesState?.favoritesAll?.filter(
        (el) => el?._id === item?._id && el?.marketId === item?.marketId
      ).length
    ) {
      return true;
    } else {
      return false;
    }
  };

  const [activeIcon, setActiveIcon] = useState();

  const toggleStar = () => {
    setActiveIcon((prevCheck) => !prevCheck);
  };

  useEffect(() => {
    if (isFavorite()) {
      setActiveIcon(true);
    } else setActiveIcon(false);
  }, [favoritesState, item]);

  const handleFavorite = (id, item) => {
    if (activeIcon) {
      dispatch(clearFavoritesAll(item));
    } else {
      if (!item?.marketBook?.marketId) return;
      dispatch(addFavoritesAll(item));
    }
  };

  return (
    <div ref={inplayItemRef} className="col-span-12 grid grid-cols-12">
      {!!inView ? (
        <>
          <div className="col-span-6 h-12 lg:col-span-5 grid grid-cols-7 border-t border-borderColorOfMarket ">
            {getScore()}
            {getName()}
          </div>

          {getOdds()}
          {renderBetPlacing()}
        </>
      ) : (
        <div className="h-12" />
      )}
    </div>
  );
};

export default InPlayItem;
